/**
 * Service: Import Jobs API
 */
angular.module('acme.common.service.importJobsApi', [
  'acme.common.service.auth'
])
  .constant('JOB_TYPE', {
    UNKNOWN: 'UNKNOWN',
    IMPORT: 'IMPORT',
    EXPORT: 'EXPORT'
  })
  .provider('ImportJobsApiService', ImportJobsApiServiceProvider);

/**
 * Service: ImportJobsApiService
 * Import Jobs API *Microservice* service
 * @constructor
 * @param {String} jobsEndpoint - the endpoint used
 * @param {Object} $http - angular $http service
 * @param AuthService
 * @return {ImportJobsApiService} -
 */
function ImportJobsApiService (jobsEndpoint, $http, AuthService) {

  var userCookie = AuthService.getCookie('user') || {};

  var requestObject = {
    headers: {
      'x-tenant-id': userCookie.tenantId
    }
  };

  return {
    list: list,
    getMappings: getMappings,
    getMappingsWithPagination: getMappingsWithPagination,
    getTypes: getTypes,
    updateMappings: updateMappings,
    create: create,
    update: update,
    get: get,
    remove: remove
  };

  /**
   * Calls the Job get all / list endpoint
   * @memberOf ImportJobsApiService
   * @public
   * @param {Number} page - Page Number
   * @param {Number} size - Page Size
   * @param {String} sort - Sort order
   * @param {String} type - Filter by Job Type (jobType): IMPORT | EXPORT
   * @return {Promise} promise that will resolve or reject with server response
   */
  function list(page, size, sort, type) {
    var _page = page || null,
      _size = size || null,
      _sort = sort || null,
      _type = type || null;

    return $http.get(jobsEndpoint, Object.assign(angular.copy(requestObject), {
      params: {
        page: _page,
        size: _size,
        sort: _sort,
        type: _type
      }
    }));
  }

  /**
   * Calls the Job Mappings endpoint
   * @memberOf ImportJobsApiService
   * @public
   * @return {Promise} promise that will resolve or reject with server response
   * @param id - Job Id
   */
  function getMappings(id) {
    return $http.get([jobsEndpoint, id, 'mappings'].join('/'));
  }

  function getMappingsWithPagination(id, page, size, sort) {
    var _page = page || null,
        _size = size || null,
        _sort = sort || null;

    // Not sure why, but, sort fields that require prefix "key_" are
    // key_tableType and key_fieldTo
    if (/fieldTo|tableType/.test(_sort)) {
      _sort = 'key_' + _sort;
    }

    return $http.get([jobsEndpoint, id, 'mappings', 'paging'].join('/'), Object.assign(angular.copy(requestObject), {
      params: {
        page: _page,
        size: _size,
        sort: _sort
      }
    }));
  }

  function getTypes(id) {
    return $http.get([jobsEndpoint, id, 'types'].join('/'));
  }

  /**
   * Calls the Update Job Mappings endpoint
   * @memberOf ImportJobsApiService
   * @public
   * @return {Promise} promise that will resolve or reject with server response
   * @param id - Job Id
   * @param {Array<Object>} mappings - Job Mappings
   */
  function updateMappings(id, mappings) {
    return $http.post([jobsEndpoint, id, 'mappings'].join('/'), mappings, requestObject);
  }

  /**
   * Calls the Job get all / list endpoint
   * @memberOf ImportJobsApiService
   * @public
   * @param {String} name - Job Name
   * @param {String} description - Job Description
   * @param {String} type - IMPORT or EXPORT (if not specified the default is UNKNOWN)
   * @return {Promise} promise that will resolve or reject with server response
   */
  function create(name, description, type) {
    return $http.post(jobsEndpoint, {
      name: name,
      description: description,
      jobType: type
    }, requestObject);
  }

  function update(job) {
    return $http.put(jobsEndpoint, job, requestObject);
  }

  /**
   * Calls the Job get by ID endpoint
   * @memberOf ImportJobsApiService
   * @public
   * @param {Number} id - Job ID
   * @return {Promise} promise that will resolve or reject with server response
   */
  function get(id) {
    return $http.get(jobsEndpoint + '/' + id, requestObject);
  }

  function remove(id) {
    return $http.delete(jobsEndpoint + '/' + id, Object.assign({}, requestObject, {
      ignoreConflict: true
    }));
  }
}

function ImportJobsApiServiceProvider () {}

ImportJobsApiServiceProvider.prototype.setEndpoint = function (endpoint) {
  this.endpoint = endpoint;
};

ImportJobsApiServiceProvider.prototype.$get = ['$http', 'AuthService', function ($http, AuthService) {
  return new ImportJobsApiService(this.endpoint, $http, AuthService);
}];

ImportJobsApiServiceProvider.$inject = [];
